import { ObjectCustomField } from "@/backend/models/customFields/objectCustomField";
import { Parameter } from "@/backend/models/parameter";
import { I18n } from "@/i18n/I18n";
import { ParameterInputType } from "@/types/parameterTypes";
import { Box, Pencil } from "lucide-react";
import { useState } from "react";
import { NonPrimitiveParameterModal } from "../parameters/NonPrimitiveParameterModal";
import { DataTypeBadge } from "./DataTypeBadge";
import { ObjectKeyVisibility } from "@/types/customFieldTypes";

export function ObjectListCard(props: { item: ObjectCustomField, parameter: Parameter, runView: boolean, disabled?: boolean }) {
  const { item, parameter, runView, disabled } = props;
  const [showEditValues, setShowEditValues] = useState(false);

  const propertiesToShow = item.objectInstance.properties.filter(property => !runView || item.isCustomChoice || property.visibility !== ObjectKeyVisibility.HIDDEN);

  return (
    <div className="object-list-card">
      <div>
        <Box color='var(--neutral-300)' />
      </div>
      <div className="object-list-card-content">
        <span className="object-list-card-title">{item.objectInstance.title}</span>
        <div className="d-flex flex-wrap gap-1">
          {propertiesToShow.map((property) => (
            <DataTypeBadge
              key={property.key}
              title={property.title || property.key}
              value={property.file?.fileName || property.value}
              type={property.type}
            />
          ))}
        </div>
      </div>
      { parameter.inputType === ParameterInputType.FREE_FORM && !disabled && (
        <button
          className="fusa-btn-medium-icon btn-blue-light"
          type="button"
          onClick={() => setShowEditValues(true)}
          title={I18n.get('editModel', { model: I18n.get('parameter'), title: parameter.title })}
          aria-label={I18n.get('editModel', { model: I18n.get('parameter'), title: parameter.title })}
        >
          <Pencil color='var(--blue-600)' />
        </button>
      )}
      { showEditValues && <NonPrimitiveParameterModal parameterId={parameter.id} setShowEditValues={setShowEditValues} runView={runView}/>}
    </div>
  );
}